module.exports = __webpack_public_path__ + "img/block2-3.936ce322.jpg";